import React, { useEffect } from "react";
import SubMenu from "../../components/menus/SubMenu";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
var abp = window.abp;
export const Videos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="p-grid">
      <div>
        <SubMenu></SubMenu>
      </div>

      <div className="p-col-12">
        <div className="card lg:p-6">
          <div className="flex align-items-center flex-column lg:flex-row">
            <Card className="lg:col-6 col-12">
              <h2>Видеа / Videos</h2>
              <Divider />
              <h3>2026</h3>
              <div style={{ position: "relative", paddingTop: "56.25%" }}>
                <iframe
                  title="New Wave"
                  width="100%"
                  height="100%"
                  src="https://vmi3168524.contaboserver.net:4433/video-playlists/embed/ehJxYBB8pGUWf2bUh2jBg7"
                  allow="fullscreen"
                  sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                  style={{ border: 0, position: "absolute", inset: 0 }}
                ></iframe>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
